import { render, staticRenderFns } from "./singleMaterial.vue?vue&type=template&id=e5a91982&"
import script from "./singleMaterial.vue?vue&type=script&lang=js&"
export * from "./singleMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports